import styled from 'styled-components';
import { Box, BoxProps } from '@components/Box';
import { themeColor, themeMediaQuery, themeSpace, themeVariant } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { JoykitColor } from '@components/themes';
import { dottedLinkStyles } from '@components/Link/DottedLink';

const PAGE_MAX_WIDTH = '1200px';

export const StyledSection = styled(Box)`
  width: 100%;
  padding-left: ${themeSpace(7)};
  padding-right: ${themeSpace(7)};

  ${themeMediaQuery('md')} {
    padding-left: ${themeSpace(10)};
    padding-right: ${themeSpace(10)};
  }

  ${themeMediaQuery('lg')} {
    max-width: ${PAGE_MAX_WIDTH};
    padding-left: 0;
    padding-right: 0;
  }
`;

export const NodesContainer = styled(Box)`
  position: relative;
  max-width: 65ch;
  margin-left: auto;
  margin-right: auto;

  ${themeMediaQuery('mobile')} {
    max-width: 100%;
  }

  h2,
  h3,
  h4,
  h5 {
    margin: ${themeSpace(8)} 0 ${themeSpace(6)};
  }

  p {
    margin: ${themeSpace(4)} 0;
  }

  .seo-content-link {
    text-decoration: underline;
    cursor: pointer;
  }

  & > *:first-child {
    margin-top: 0;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const StyledTitle = styled(Text)`
  font-weight: 600;
`;

export const StyledButton = styled('button')`
  ${dottedLinkStyles}
  ${themeVariant('featureCopy17')}
  display: block;
  margin-top: ${themeSpace(6)};
  margin-left: auto;
  margin-right: auto;
  font-weight: 500;
  color: ${themeColor('mono1')};
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;

  &:hover {
    color: ${themeColor('actionPurple3')};
  }

  ${themeMediaQuery('lg')} {
    ${themeVariant('featureLink20')}
  }
`;

export const StyledGradient = styled(Box)<{ gradientColor?: JoykitColor }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    ${({ gradientColor }) => (gradientColor ? themeColor(gradientColor, 1) : 'white')}
  );
`;

export const RatingLink = styled.a`
  ${dottedLinkStyles}
  color: inherit;
  font: inherit;

  &:hover {
    color: ${themeColor('actionPurple3')};
  }
`;

export const RatingWrapper = styled(Box)`
  max-width: 65ch;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${themeSpace(8)};

  /* cancel the AppRatingRow's own bottom margin so this wrapper controls spacing */
  > * {
    margin-bottom: 0;
  }

  ${themeMediaQuery('mobile')} {
    max-width: 100%;
  }
`;

export const ReviewsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${themeSpace(8)};
`;

export const ReviewCard = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${themeSpace(4)};
  max-width: 65ch;
  margin-left: auto;
  margin-right: auto;

  ${themeMediaQuery('mobile')} {
    max-width: 100%;
  }
`;

export const ReviewHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeSpace(4)};

  ${themeMediaQuery('mobile')} {
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

export const ReviewerInfo = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${themeSpace(4)};

  ${themeMediaQuery('mobile')} {
    flex-direction: column;
    align-items: flex-start;
    gap: ${themeSpace(1)};
  }
`;

export const ReviewerName = styled(Text)`
  font-weight: 600;
`;

export const ReviewerLocation = styled(Text)`
  font-weight: 400;
  font-style: italic;
`;

export const ReviewStars = styled(Box)`
  display: flex;
  gap: ${themeSpace(1)};
  color: #f5c518;
`;

export const ReviewContent = styled(Text)``;
